import { MutOpt } from '@/app/api';
import { queryClient } from '@/lib/query-client';
import { createQueryKeys } from '@/lib/query-factory';
import { queryOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import * as api from './docs.api';

const catalogKeys = createQueryKeys('docs.catalog');
const notificationKeys = createQueryKeys('docs.notification');

export const docsQueries = {
  catalogKeys,
  notificationKeys,
  byProject: (projectId: number) =>
    queryOptions({
      queryKey: [...catalogKeys.detail(`project:${projectId}`)],
      queryFn: () => api.fetchCatalogContentByProject(projectId),
      enabled: !!projectId,
    }),
  subscription: (catalogId: number) =>
    queryOptions({
      queryKey: [...notificationKeys.detail(`catalog:${catalogId}`)],
      queryFn: () => api.getCatalogSubscription(catalogId),
      enabled: !!catalogId,
    }),
};

type ToggleArgs = { catalogId: number };

export const docsMutations = {
  subscribe: (): MutOpt<(args: ToggleArgs) => Promise<void>> => ({
    mutationFn: ({ catalogId }: ToggleArgs) => api.subscribeCatalog(catalogId),
    onSuccess: (_, { catalogId }) => {
      queryClient.invalidateQueries({
        queryKey: notificationKeys.detail(`catalog:${catalogId}`),
      });
      toast.success('Subscribed to document updates');
    },
    onError: (error: Error) => {
      toast.error('Failed to subscribe', { description: error.message });
    },
  }),
  unsubscribe: (): MutOpt<(args: ToggleArgs) => Promise<void>> => ({
    mutationFn: ({ catalogId }: ToggleArgs) =>
      api.unsubscribeCatalog(catalogId),
    onSuccess: (_, { catalogId }) => {
      queryClient.invalidateQueries({
        queryKey: notificationKeys.detail(`catalog:${catalogId}`),
      });
      toast.success('Unsubscribed from document updates');
    },
    onError: (error: Error) => {
      toast.error('Failed to unsubscribe', { description: error.message });
    },
  }),
};
